import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { IonContent, IonLoading, IonCard, IonCardContent, IonGrid, IonRow, IonCol } from '@ionic/react';

// Components
import { HeaderComponent, ContactComponent, MobileContactMessageComponent, WebContactMessageComponent } from '../../../components';

// Helpers
import { extractConfigPage, isBranchEnabled, saveModal, clearModal, sendEventContactPage } from '../../../helpers';

// Services
import { VirtualCredentialService } from './../../../services';

// Contexts
import { AppContext } from '../../../contexts';

// Hooks
import { useForm } from '../../../hooks/useForm';

// Validators
import { FormsValidator } from '../../../validators';

// Constants
import { APP_CONFIG } from '../../../constants';

// Sass
import './ContactPage.scss';


export const ContactPage = () => {

    const inputs = {

        message: 'message',
        name: 'name'
    };

    const { gonogo } = useSelector(state => state.app);
    const history = useHistory();
    const location = useLocation();
    const pageConfig = extractConfigPage(location);

    const { isWeb } = useContext(AppContext);
    const [contactData, setContactData] = useState({ data: null, loading: false, error: null, showModal: false, status: null });
    const [{ message, name }, handleInputChange, reset] = useForm({message: '', name: ''});
    const [validation, setValidation] = useState({ summary: null, formValid: false, formComplete: false });
    const [showInputName, setShowInputName] = useState(false);

    useEffect(() => {
        
        const validationsFunctions = [
            () => FormsValidator.required(pageConfig, message, inputs.message),
            () => FormsValidator.maxLength(pageConfig, message, inputs.message),
            () => FormsValidator.minLength(pageConfig, message, inputs.message)
        ];

        // Si la sucursal no está habilitada, debo agregar las validaciones del campo establecimiento
        if ( !isBranchEnabled() ) {

            validationsFunctions.push(...[
                () => FormsValidator.required(pageConfig, name, inputs.name),
                () => FormsValidator.maxLength(pageConfig, name, inputs.name),
                () => FormsValidator.minLength(pageConfig, name, inputs.name)
            ]);
        }

        const validations = FormsValidator.summary(validationsFunctions);

        setValidation({
            summary: validations.filter(v => !v.valid ),
            formValid: validations.formValid,
            formComplete: isBranchEnabled() ? 
                message.length > 0 && message.length <= pageConfig.rules.inputs.message.maxLength.value :
                message.length > 0 && message.length <= pageConfig.rules.inputs.message.maxLength.value &&
                name.length > 0 && name.length <= pageConfig.rules.inputs.name.maxLength.value
        });
        
    }, [message, name]);

    /**
     * Se encarga de mostrar el input del establecimiento en caso que el usuario no esté habilitado
     */
    useEffect(() => {

        if (!isBranchEnabled()) {

            setShowInputName(true);
        }
        else {
            setShowInputName(false);
        }

    }, [gonogo]);

    const handleMessage = async (e) => {

        e.preventDefault();

        if (validation.formComplete && validation.formValid) {

            setContactData({ data: null, loading: true, error: null });

            try {
                
                const resp = await VirtualCredentialService.sendCommentary({message, name});
                setContactData({
                    loading: false,
                    error: null,
                    data: resp,
                    showModal: true,
                    status: true
                });

            } catch ({error}) {
                
                setContactData({
                    data: null,
                    loading: false,
                    error: error.message,
                    showModal: true,
                    status: false
                });
            }
            finally {

                // Analytics
                sendEventContactPage();

                saveModal(true);
                reset();
            };
        }
    };

    const handleClick = (redirectTo) => {

        clearModal();
        setContactData({
            data: null,
            loading: false,
            error: null,
            showModal: false,
            status: false
        });

        history.push(redirectTo);
    };

    return (
        <>
            <HeaderComponent
                title={pageConfig.title}
            />

            <IonLoading
                isOpen={contactData.loading}
                message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
            />

            {/* MOBILE - MODAL */}
            {contactData.showModal && !isWeb &&

                <MobileContactMessageComponent 
                    state={contactData} 
                    history={history}
                    pageConfig={pageConfig}
                    handleFinish={handleClick} 
                    setState={setContactData}
                />
            }

            {/* PAGE - MOBILE - WEB */}
            {!contactData.showModal &&
                <IonContent className="ion-padding">

                    {!isWeb &&

                        <ContactComponent 
                            message={ message }
                            name={ name }
                            handleInputChange={ handleInputChange }
                            pageConfig={ pageConfig }
                            handleMessage={handleMessage}
                            inputs={inputs}
                            validation={validation}
                            showInputName={showInputName}
                        />
                    }

                    {
                        isWeb &&
                        <IonGrid>
                            <IonRow className='ion-text-left'>
                                <IonCol>
                                    <h1>Contactate con nosotros</h1>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonCard>
                                        <IonCardContent className="ion-text-center">

                                            <ContactComponent 
                                                message={ message }
                                                name={ name }
                                                handleInputChange={ handleInputChange }
                                                pageConfig={ pageConfig }
                                                handleMessage={handleMessage}
                                                inputs={inputs}
                                                validation={validation}
                                                showInputName={showInputName}
                                            />

                                        </IonCardContent>
                                    </IonCard>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    }

                </IonContent>
            }

            {/* WEB - MODAL */}
            {contactData.showModal && isWeb &&

                <WebContactMessageComponent 
                    state={ contactData }
                    pageConfig={ pageConfig }
                    handleClick={handleClick}
                />
            }
        </>
    )
}
